import cleanedFilename from '~/util/cleanedFilename';

export default {
  BUTTON: `${cleanedFilename(__filename)}-button`,
};
